import { HttpEvent, HttpResponse } from '@angular/common/http';
import { isTruthy } from '@nestech/utils';

export const isHttpResponse = (event: HttpEvent<any>): event is HttpResponse<any> => event instanceof HttpResponse;

export const isConverableJsonResponse = (event: HttpEvent<any>): event is HttpResponse<any> => {
  if (!isHttpResponse(event)) {
    return false;
  }
  const hasJsonHeader = event.headers.get('Content-Type')?.startsWith('application/json');
  const hasBody = event.body;
  const isNotBlob = event.body instanceof Blob === false;
  const isNotArrayBuffer = event.body instanceof ArrayBuffer === false;
  return [hasBody, isNotBlob, isNotArrayBuffer, hasJsonHeader].every(isTruthy);
};
